(function () {
    'use strict';
    a3_pilot_reports.directive('calendarNotifications', calendarNotifications);

    /**
       * @memberof PilotReports
       * @ngdoc directive
       * @name calendarNotifications
       * @restrict E
       * @description
       *   Implementation of crew meals
       *
       *   Display the notifications
       * @attr {String} draftReport 
       * @attr {String} completedReports  
       * @example
       *   Usage:
       *   <calendar-notifications draft-reports="0" completed-reports="0"></calendar-notifications>
       *   
       * @ngInject
       */
    function calendarNotifications($location, $uibModal, $route, MessageFactory, MemoFactory, 
        AutolandFactory, ScheduleAcknowledgeFactory, LeaveRequestFactory, 
         CheckInFactory, GroundDutyFactory, ExpiriesFactory, CrewRouteFactory, CatIIFactory, UserFactory, RequestFactory) {

        function link($scope, attrs) {
            $scope.gotoUnreadMemos = gotoUnreadMemos;
            $scope.gotoMessages = gotoMessages;
            $scope.gotoLeaves = gotoLeaves;
            $scope.reportsCounter = getReportsCounter();
            $scope.acknowledge = acknowledge;
            $scope.showPanel = false;
            $scope.showAutolandReminder = false;
            $scope.showAutolandAlert = false;
            $scope.showScheduleChangesReminder = false;
            $scope.hasScheduleChanges = false;
            $scope.openCheckIn = openCheckInModal;
            $scope.showCheckInAction = false;
            $scope.showExpiriesAlertCalendar = false;
            $scope.showPasswordExpiryAlert = false;
            $scope.expiryList = [];
            $scope.expiredExpiriesList = [];
            $scope.getBorderClass = getBorderClass;
            $scope.showSubmissionDeadlineAlertCalendar = false;
            $scope.submissionDeadline = null;
           
            $scope.hasManualEntry = false;
            $scope.gotoGroundDutyInfo = gotoGroundDutyInfo;
            $scope.removeManualEntry = removeManualEntry;

            $scope.daysDiff = daysDiff;

            $scope.removeFlightTrainingManualEntry = removeFlightTrainingManualEntry;
            $scope.gotoCrewRouteInfo = gotoCrewRouteInfo;
            
            $scope.pastTrainingsViewSummary = pastTrainingsViewSummary;
            $scope.viewPastTrainings = false;
            $scope.removePendingGDEntry = removePendingGDEntry;
            $scope.removePendingFlightEntry = removePendingFlightEntry;
    
            $scope.gotoFlightInfo = gotoFlightInfo;

            $scope.showExpiredExpiriesAlertCalendar = false;

            function pastTrainingsViewSummary() {
                $scope.viewPastTrainings = ! $scope.viewPastTrainings
            }

            $scope.catII = { 
                showCatIIReminder: false,
                autolandCount: 0, 
                flightsLeft: 0, 
                totalOAFlights: 0,
                hasOAFlights: false
            };

            $scope.passwordExpiry = {
                showAlert: false,
                lastChange: null,
                daysLeft: null  
            };

            function daysDiff(date) {
                var now = moment();
                var expiryDate = moment(date)
    
                return expiryDate.diff(now, 'days');
            }

            function getBorderClass(){
                var classStyle = '';
                if($scope.catII.catIICount >= 2){
                    classStyle = 'border-left-green';
                }else{
                    classStyle = 'border-left-orange';
                }
                return classStyle;
            }

            setupView();

            function setupView() {

                $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
                $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();
                $scope.leaveRequest = LeaveRequestFactory.getLeaveRequestInformation();
                $scope.leaveRequestCloseDate = $scope.leaveRequest ? moment($scope.leaveRequest.CloseDate).format('Do of MMMM') : null;

                //Get count of unread memos but remove the ones that belong in 'Training Surveys' Category
                var unreadMemosCount = 0;
                MemoFactory.getUnreadMemos(function (memos) {

                    //remove memos that belong in "Training Surveys" category
                    for (var i = 0; i < memos.length; i++) {
                        if (memos[i].Category != "Training Surveys") {
                            unreadMemosCount++;
                        }
                    }

                    $scope.unreadMemosCount = unreadMemosCount;
                    $scope.hasScheduleChanges = ScheduleAcknowledgeFactory.hasScheduleChanges();
                    $scope.showCheckInAction = showCheckInAction();
                    $scope.showScheduleChangesReminder = showScheduleChangesReminder();
                    $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
                    prepareAutolandData();
                    prepareCatIIData();
                    preparePasswordExpiryData();
                    
                    $scope.showExpiriesAlertCalendar = showExpiriesAlertCalendar();
                    $scope.showSubmissionDeadlineAlertCalendar = showSubmissionDeadlineAlertCalendar();
                    $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();

                    // Expiried Expiries
                    $scope.showExpiredExpiriesAlertCalendar = showExpiredExpiriesAlertCalendar().then(function(result) {
                        $scope.showExpiredExpiriesAlertCalendar = result;
                    });                 
                    $scope.expiredExpiriesList = ExpiriesFactory.getExpiredExpiries().then(function (list) {
                        $scope.expiredExpiriesList = list;
                    });
                    $scope.showPanel = showNotificationPanel();

                    showReminderModal();
                });

                 // Used for pending trainings notification        
                 $scope.manualGroundDuties = GroundDutyFactory.getManualGroundDutiesFromStorage();
                 findManualEntries($scope.manualGroundDuties);
     
                 $scope.manualFlightTrainings = CrewRouteFactory.getManualFlightTrainingsFromStorage();
                 findManualFlightTrainingEntries($scope.manualFlightTrainings);

                // Get incomplete past duties
                // Ground duties            
                $scope.totalIncompleteGD = [];
                var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
                $scope.totalIncompleteGD = groundDuties.filter(x => x.isManualEntry == true && !x.hasPendingCourse);

                // Flight duties
                $scope.totalIncompleteFlightDuties = [];
                var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
                $scope.totalIncompleteFlightDuties = crewRoutes.filter(x => x.isManualEntry && !x.hasPendingCourse);       
        
                if($scope.totalIncompleteGD.length > 0 || $scope.totalIncompleteFlightDuties.length > 0){
                    $scope.showPastTrainingsSummary = true;
                }

            }

            function prepareAutolandData() {
                //Get autoland procedures
                var autoland = AutolandFactory.getAutolandFromStorage();
                $scope.autolandCount = 0;
                $scope.flightsLeft = 0;
                $scope.hasAEFlights = false;
                var totalAEFlights = 0;
                if (autoland != null) {
                    $scope.autolandCount = autoland.autolandCount;
                    $scope.flightsLeft = autoland.flightsLeft;
                    totalAEFlights = autoland.totalAEFlights;
                    $scope.hasAEFlights = autoland.totalAEFlights > 0;
                }
                if( $scope.autolandCount == 0 && $scope.hasAEFlights && totalAEFlights > 4 && $scope.flightsLeft > 0 && $scope.flightsLeft < 10){
                    $scope.showAutolandAlert = true;
                }

                if (AutolandFactory.canShowAutolandModal() && $scope.autolandCount == 0 && $scope.hasAEFlights && totalAEFlights > 4 && $scope.flightsLeft > 0 && $scope.flightsLeft < 10) {
                    $scope.showAutolandReminder = true;
                }
                else {
                    $scope.showAutolandReminder = false
                }
            }

            function preparePasswordExpiryData() {
                //update PasswordExpiry scope:
                var user = UserFactory.getUser();
                if(user && user.passwordLastChangeDate){
                    
                    var today = new Date();
                    var lastChangeDate = new Date(user.passwordLastChangeDate);
                    var expirationDate =  lastChangeDate.AddDays(90);
                    // how many days until duty date
                    // var trimmedToday = new Date(today);
                    // var trimmedLastChangeDate = new Date(lastChangeDate);
                    var diffDays = Date.DifferenceInDays(today.trimTime(), expirationDate.trimTime());
                
                    $scope.passwordExpiry = {
                        showAlert: diffDays && diffDays <= 14,
                        lastChange: lastChangeDate,
                        daysLeft: diffDays  
                    };
                }
            }

            function prepareCatIIData() {
                //update catII scope:
                var catII = CatIIFactory.getCatIIFromStorage();
                if (catII != null) {
                    $scope.catII.catIICount = catII.catIICount;
                    $scope.catII.flightsLeft = catII.flightsLeft;
                    $scope.catII.totalOAFlights = catII.totalOAFlights;
                    $scope.catII.hasOAFlights = catII.totalOAFlights > 0;
                }
                if (CatIIFactory.canShowCatIIModal() && $scope.catII.catIICount < 2 && $scope.catII.hasOAFlights 
                        && $scope.catII.totalOAFlights > 4 && $scope.catII.flightsLeft < 10) {  
                    $scope.catII.showCatIIReminder = true;
                }
                else {
                    $scope.catII.showCatIIReminder = false
                }
            }

            function showScheduleChangesReminder() {
                return ScheduleAcknowledgeFactory.showScheduleChangesModal();
            }

            function showCheckInAction() {
                var retVal = false;
                var checkInInfo = CheckInFactory.getCheckInInfoFromStorage();
                if (checkInInfo && checkInInfo.AimsId > 0) {
                    var now = moment.utc();

                    //Fetch FROM
                    //Convert from Date UTC to Moment UTC

                    var std = moment.utc(checkInInfo.STD);
                    var minFetchTime = moment(std).add(-2, 'hours');

                    //Fetch UNTIL    
                    var maxFetchTime = moment(std).add(10, 'minutes');

                    var isAfter = now.isAfter(minFetchTime);
                    var isBefore = now.isBefore(maxFetchTime);

                    if (isAfter && isBefore) {
                        retVal = true;
                    }

                    //console.log({"isAfter":isAfter, "isBefore": isBefore, "now":now, "std":std, "minFetchTime":minFetchTime,"maxFetchTime":maxFetchTime});
                }

                return retVal;
            }

            function showNotificationPanel() {
                var showPanel = false;

                if (($scope.draftReports + $scope.completedReports) > 9
                    || !$scope.$root.idbSupported
                    || ($scope.unreadMemosCount > 0 || $scope.number_of_messages_not_readen > 0)
                    || $scope.hasAEFlights
                    || $scope.catII.hasOAFlights
                    || ($scope.leaveRequest && $scope.leaveRequest.GroupStatus == 'OPEN')
                    || $scope.hasScheduleChanges
                    || $scope.showCheckInAction
                    || $scope.hasManualEntry
                    || $scope.showPastTrainingsSummary
                    || $scope.passwordExpiry.showAlert
                    || $scope.showSubmissionDeadlineAlertCalendar
                    || $scope.showAutolandAlert 
                    ) {
                    showPanel = true;
                }


                return showPanel;
            }

            /**
      * Finds the dates with manual pending training entries on their schedule
      * @memberof CalendarCtrl        
      */
            function findManualEntries(manualDuties) {
                for (var i = 0; i < manualDuties.length; i++) {
                    if (manualDuties[i].hasPendingCourse) {
                        $scope.hasManualEntry = true;
                        break;
                    }
                }
            }

            function findManualFlightTrainingEntries(manualFlightTrainings) {           
                for (var i = 0; i < manualFlightTrainings.length; i++) {
                    if (manualFlightTrainings[i].hasPendingCourse) {
                        $scope.hasManualEntry = true;
                        break;
                    }
                }
            }

            function removePendingGDEntry(groundDuty){
                $scope.totalIncompleteGD.find(x => x.Id == groundDuty).isManualEntry = false;
                GroundDutyFactory.removeGroundDuty(groundDuty);
                return $scope.totalIncompleteGD;          
            }
    
            function removePendingFlightEntry(dutyNo, dutyDay){
                $scope.totalIncompleteFlightDuties.find(x => x.FlightId == dutyNo).isManualEntry = false;
                return $scope.totalIncompleteFlightDuties;    
            }
    
            function getReportsCounter() {
                return parseInt($scope.draftReports) + parseInt($scope.completedReports);
            }
            /**
             * Redirect to Library Info with filter enabled
             * @memberof calendarNotifications
             */
            function gotoUnreadMemos() {
                $location.path('/memos/unread');
            }

            /**
            * Redirect to messages
            * @memberof calendarNotifications
            */
            function gotoMessages() {
                $location.path('/messages/');
            }

            /**
             * Redirect to leaves
             * @memberof CalendarCtrl
             */
            function gotoLeaves() {
                $location.path('/leaverequest/');
            }

           /**
           * Redirect to crewRoute Info
           * @memberof CalendarCtrl
           */
            function gotoCrewRouteInfo(dutyNo, dutyDay) {
                $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
            }

            /**
            * Redirect to groundDuty Info
            * @memberof CalendarCtrl
            */
            function gotoGroundDutyInfo(GroundDutyId) {
                $location.path('/groundDuty/' + GroundDutyId);
            }

            function gotoFlightInfo(FlightId) { 
                $location.path('/flightinfo/' + FlightId);
            }
            
            /** Removes manual training entry */
            function removeManualEntry(groundDuty) {
                GroundDutyFactory.removeGroundDuty(groundDuty);
                $route.reload();
            }

            function removeFlightTrainingManualEntry(dutyNo, dutyDay) {
                CrewRouteFactory.removeFlightTraining(dutyNo, dutyDay);
                setupView();
                $route.reload();
            }
 
            /**
            * Gets showSubmissionDeadlineAlert value
            * @memberof calendarNotifications
            */
            function showSubmissionDeadlineAlertCalendar() {
                return RequestFactory.showSubmissionDeadlineAlert();
            }

            /**
             * Shows the bootbox for autoland and schedule acknowledge reminder
             * @memberof calendarNotifications
             */
            function showReminderModal() {
                var showExpiriesReminder = ExpiriesFactory.showExpiriesModal();
                var showSubmissionDeadlineReminder = RequestFactory.showSubmissionDeadlineModal();

                if ($scope.showAutolandReminder || $scope.catII.showCatIIReminder || $scope.showScheduleChangesReminder || showExpiriesReminder || showSubmissionDeadlineReminder) {
                    var submissionEndDate = null;
                    if($scope.submissionDeadline){
                        submissionEndDate = $scope.submissionDeadline.submissionEndDate;
                    }
                    var modalInstance = $uibModal.open({
                        templateUrl: 'views/CalendarNotifications/dlgReminderModal.html',
                        controller: 'ReminderModalCtrl',
                        size: 'md',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            showAutolandReminder: function () {
                                return $scope.showAutolandReminder;
                            },
                            showCatIIReminder: function () {
                                return $scope.catII.showCatIIReminder;
                            },
                            showScheduleChangesReminder: function () {
                                return $scope.showScheduleChangesReminder;
                            },
                            showExpiriesReminder: function () {
                                return showExpiriesReminder;
                            },
                            showSubmissionDeadlineReminder: function () {
                                return showSubmissionDeadlineReminder;
                            },
                            submissionEndDate: function () {
                                return submissionEndDate;
                            }

                        }
                    });

                }
            }

            /**
            * Open the "Acknowledge schedule changes" Modal
            * @memberof CalendarCtrl
            */
            function acknowledge() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/CalendarNotifications/dlgAcknowledgeChanges.html',
                    controller: 'AcknowledgeModalCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false
                });
            }

            function showExpiriesAlertCalendar() {
                return ExpiriesFactory.showExpiriesAlert();
            }

            /**
            * Open Check in Modal
            * @memberof CalendarCtrl
            */
            function openCheckInModal() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgCheckIn.html',
                    controller: 'CheckInModalCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false
                });
            }

            function showExpiredExpiriesAlertCalendar() {
                return ExpiriesFactory.showExpiredExpiriesAlert();
            }
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/CalendarNotifications/calendarNotifications.tpl.html',
            scope: {
                draftReports: '@',
                completedReports: '@',
                hasUnsetTraining: '@'
            },
            link: link
        }
    }

})();